import React from 'react'
import { SelectField } from '../../../../../../../components'
import { useGlobal } from '../../../../../../../shared'
import { highestInt, months } from '../../../../../../../shared/utils/constants'
import { useDispatch, useSelector } from 'react-redux'
import {
  setOpenExportModal,
  setOpenExportModalFee,
  setOpenExportModalIndividualFee,
} from '../../../../../../../redux/globalSlice'
import TextField from '../../../../../../../components/TextField/Textfield'
import { urls } from '../../../../../../../shared/config'
import { Box, Modal, Typography } from '@mui/material'
import classes from './ExportTransportReport.module.css'

const ExportIndividualFeeReport = ({ open }) => {
  const [formValues, setFormValues] = React.useState({
    schoolName: '',
    month: '',
    class: '',
    grade: '',
  })
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 627,
    bgcolor: 'background.paper',
    border: 'none',
    boxShadow: 24,
    p: 4,
    outline: 'none',
    borderRadius: '12px', // optional: looks better
  }

  // const open = useSelector((state) => state.global.openExportModal)
  const dispatch = useDispatch()
  const handleClose = () => dispatch(setOpenExportModalIndividualFee(false))

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className={classes.container}>
          <div
            style={{
              marginBottom: '20px',
            }}
            className="header-registration"
          >
            <p className="modalheadtxt">Export Fee Report</p>
          </div>
        </div>
        <SelectField
          placeholder={'Select'}
          options={months?.map((m) => ({
            value: m,
            label: m,
          }))}
          value={formValues?.month}
          onChange={(selectedOption) => setFormValues({ ...formValues, month: selectedOption })}
          label={'Month'}
          required={true}
          width={'100%'}
        />
        <div className={classes.bottom}>
          <button onClick={handleClose} className="white-button">
            {'Cancel'}
          </button>

          <button onClick={handleClose} className={`primary-button`}>
            {'Export'}
          </button>
        </div>
      </Box>
    </Modal>
  )
}

export default ExportIndividualFeeReport
